export default __webpack_public_path__ + "static/media/pediatric.dafcf676.png";